import { applicationSettings } from './application';
import rangeSettings from './rangeSettings';
import constants from './masterConstants';

const getRangeConstants = () => {
  if (applicationSettings.applicationName in rangeSettings)
    return rangeSettings[applicationSettings.applicationName];

  throw new Error('Range specific constants missing');
};

const rangeConstants = getRangeConstants();

export default Object.assign(constants, {
  GRID: rangeConstants.grid,
  DYNAMIC_GRID: rangeConstants.dynamicGrid,
  DEFAULT_FILTER: rangeConstants.defaultFilter,
  POST_WIDTH: rangeConstants.postWidth,
  PAD_HEIGHT: rangeConstants.padHeight,
  ROOM_MAX: rangeConstants.roomMax,
  ROOM_MIN_DESKTOP: rangeConstants.roomMinDesktop,
  ROOM_MIN_MOBILE: rangeConstants.roomMinMobile,
  ROOM_MIN_SUMMARY: rangeConstants.roomMinSummary,
  DISTANCE_BETWEEN_ATTACHMENTS: rangeConstants.distanceBetweenAttachments,
  ZOOMABLE_SCENE: rangeConstants.zoomableScene,
  WALL: rangeConstants.wall,
  SIDEWALL: rangeConstants.sideWall,
  CANVAS_MARGINS: rangeConstants.canvasMargins,
  CANVAS_MARGINS_KIOSK: rangeConstants.canvasMarginsKiosk,
  CANVAS_MARGINS_MOBILE: rangeConstants.canvasMarginsMobile,
  CANVAS_MARGINS_PORTRAIT_PERCENTUAL:
    rangeConstants.canvasMarginsPortraitPercentual,
  CANVAS_MARGINS_SUMMARY: rangeConstants.canvasMarginsSummary,
  APPLICATION_NAME: applicationSettings.applicationName,
  DISPLAY_SECTION_MEASUREMENTS: rangeConstants.displaySectionMeasurements,
  MOUNTING_RAILS: rangeConstants.mountingRails,
  SECTION_SNAPPING_DISTANCE: rangeConstants.sectionSnappingDistance,
  SHOW_MULTIPLE_ERRORS: rangeConstants.showMultipleErrors,
  DYNAMIC_WALL_LIMITS: rangeConstants.dynamicWallLimits,
  DISPLAY_TABLE_MEASUREMENTS: rangeConstants.displayTableMeasurements,
  DISPLAY_MEASUREMENT: rangeConstants.displayMeasurement,
  MEASUREMENTS_SETTINGS: rangeConstants.measurements,
  HIDE_INFO_ICON_FOR_TYPE: rangeConstants.hideInfoIconForType,
  BULK_ARTICLES: rangeConstants.bulkArticles,
  COLOR_CODES: rangeConstants.colorCodes,
  SCENE: rangeConstants.scene,
  CUTTABLE_MOUNTING_RAIL_PROTRUSION_THRESHOLD:
    rangeConstants.cuttableMountingRailProtrusionThreshold,
  LINK_CARD_SKYTTA_IMAGE_FILENAME: rangeConstants.linkCardSkyttaImageFilename,
});
